import React, { Component } from 'react'

type HeadingSize = 'small' | 'large' | 'extraLarge'
type HeadingSizeRegistery = Record<HeadingSize, string>

interface HeadingProps {
  text: string
  size?: HeadingSize
  className?: string
  id?: string
}

export default class Heading extends Component<HeadingProps> {
  headingSizes: HeadingSizeRegistery = {
    small: 'text-sm',
    large: 'text-lg',
    extraLarge: 'text-xl'
  }

  get className () {
    const { size, className } = this.props
    const base = 'font-medium'
    const headingSize = size ? this.headingSizes[size] : 'text-base'
    return `${base} ${headingSize} ${className}`
  }

  render () {
    return (
      <h3 className={this.className} id={this.props.id} style={{ whiteSpace: "pre" }}>{this.props.text}</h3>
    )
  }
}
